import { Link } from "react-router-dom";
import { ArrowUpRight, Wallet, Home, Briefcase, GraduationCap, Car, Building2, TrendingUp, ArrowLeftRight, Landmark, HandCoins, PiggyBank, CreditCard } from "lucide-react";
import { inrCompact } from "../../lib/site";

const ICONS = { Wallet, Home, Briefcase, GraduationCap, Car, Building2, TrendingUp, ArrowLeftRight, Landmark, HandCoins, PiggyBank, CreditCard };

export default function ProductCard({ product, index = 0 }) {
  const Icon = ICONS[product.icon] || Landmark;
  return (
    <Link to={`/loans/${product.slug}`} data-testid={`product-card-${product.slug}`}
      className="card-site group p-7 flex flex-col min-h-[260px]">
      <div className="flex items-start justify-between">
        <span className="w-12 h-12 rounded-2xl bg-brand-red/5 text-brand-red flex items-center justify-center transition-colors duration-300 group-hover:bg-brand-red group-hover:text-white">
          <Icon size={22} strokeWidth={1.8} />
        </span>
        <ArrowUpRight size={18} className="text-brand-muted/40 transition-all duration-300 group-hover:text-brand-red group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
      </div>
      <h3 className="mt-5 font-heading text-xl font-bold text-brand-dark">{product.name}</h3>
      <p className="mt-2 text-sm text-brand-muted leading-relaxed flex-1">{product.short_desc}</p>
      <div className="mt-5 pt-4 border-t border-black/5 flex items-center justify-between text-xs">
        <span className="text-brand-muted">From <span className="font-bold text-brand-dark">{inrCompact(product.min_amount)}</span></span>
        <span className="font-bold text-brand-red">{product.rate}</span>
      </div>
    </Link>
  );
}
